module.exports = __webpack_public_path__ + "img/pengaduan.e1690162.png";